import SvgIcon from '@mui/material/SvgIcon';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel, {
  FormControlLabelProps,
} from '@mui/material/FormControlLabel';

type FormCheckboxInputProps = Pick<
  FormControlLabelProps,
  'label' | 'name' | 'id' | 'disabled' | 'labelPlacement' | 'value' | 'onChange'
> & {
  hide?: boolean;
  checked?: boolean;
};

export function FormCheckboxInput({
  hide,
  checked,
  ...props
}: FormCheckboxInputProps) {
  if (hide) return <></>;
  return (
    <FormControlLabel
      {...props}
      control={
        <Checkbox
          sx={{padding: '4px 12px'}}
          icon={<UnCheckedIcon />}
          checkedIcon={<CheckedIcon />}
          checked={checked}
        />
      }
    />
  );
}

function UnCheckedIcon() {
  return (
    <SvgIcon>
      <svg
        width='20'
        height='20'
        viewBox='0 0 20 20'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'>
        <rect
          x='0.5'
          y='0.5'
          width='19'
          height='19'
          rx='5.5'
          stroke='#BABAC8'
        />
      </svg>
    </SvgIcon>
  );
}
function CheckedIcon() {
  return (
    <SvgIcon>
      <svg
        width='20'
        height='20'
        viewBox='0 0 20 20'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'>
        <rect x='0.5' y='0.5' width='19' height='19' rx='5.5' fill='#EB6924' />
        <rect
          x='0.5'
          y='0.5'
          width='19'
          height='19'
          rx='5.5'
          stroke='#EB6924'
        />
        <path
          d='M14.6668 6.5L8.25016 12.9167L5.3335 10'
          stroke='white'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </SvgIcon>
  );
}
